import { TOUR_IDS } from "@demandproai/shared";
import RenderIf from "../render-if/Renderif";
import useCaseListTour from "../../hooks/useCaseListTour";
import useTourRefresher from "../../hooks/useTourRefresher";
import TourRefresherPrompt from "./TourRefresherPrompt";

const REFRESHER_BODY = "It has been a while. Want a quick walk through of the case list again?";

const CaseListTourRunner = ({ isReady }) => {
   const { Tour } = useCaseListTour({ isReady });
   const { isOffering, acceptRefresher, declineRefresher } = useTourRefresher({
      tourId: TOUR_IDS.CASE_LIST,
   });

   return (
      <>
         {Tour}

         <RenderIf shouldRender={isOffering}>
            <TourRefresherPrompt
               body={REFRESHER_BODY}
               onAccept={acceptRefresher}
               onDecline={declineRefresher}
            />
         </RenderIf>
      </>
   );
};

export default CaseListTourRunner;
